import { jsx as i, jsxs as c } from "react/jsx-runtime";
import A from "../MediaButtons/MediaButtons.js";
import "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import F from "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import z from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import O from "@material-ui/core/styles/useTheme";
import R from "@material-ui/core/styles/withStyles";
import $ from "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import L from "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { CarouselModal as M, PrevArrow as H, ArrowSize as w, NextArrow as U, partitionArray as j } from "@propify-tenant-client/common";
import g from "classnames";
import { useState as y, createRef as V, useMemo as u } from "react";
import W from "react-slick";
const D = (a) => z({
  container: {
    position: "relative",
    width: "100%",
    height: 500,
    [`${a.breakpoints.down("sm")}`]: {
      height: 350
    }
  },
  firstPage: {
    display: "flex !important",
    flex: "1 1",
    flexBasis: "100%",
    flexDirection: "row",
    gap: 4,
    height: 500,
    columns: "2 50%"
  },
  slideBlock: {
    position: "relative",
    display: "flex",
    flex: 1,
    alignItems: "flex-end",
    justifyContent: "center",
    overflow: "hidden",
    backgroundColor: "#eaeaea",
    backgroundPosition: "50%",
    backgroundSize: "cover"
  },
  imageCounter: {
    position: "absolute",
    top: "15px",
    right: "18px",
    padding: "17px",
    color: "#2c5982",
    fontWeight: 700,
    fontSize: "18px",
    backgroundColor: "#fff"
  },
  buttonGroup: {
    marginBottom: 10,
    background: "rgba(0, 0, 0, 0.7)",
    backdropFilter: "blur(4px)",
    "& button": {
      paddingLeft: 13,
      color: "#fff",
      textTransform: "none",
      borderColor: "rgba(255, 255, 255, 0.1) !important"
    }
  },
  gridPage: {
    display: "grid !important",
    flex: 1,
    gridTemplateRows: "250px 250px",
    gridTemplateColumns: "50% 50%",
    gap: 4,
    "& div": {
      overflow: "hidden",
      backgroundColor: "#eaeaea",
      "& img": {
        width: "100%",
        minHeight: "100%"
      }
    }
  },
  mobilePage: {
    display: "grid !important",
    flex: 1,
    height: 350,
    "& div": {
      overflow: "hidden",
      backgroundColor: "#eaeaea",
      "& img": {
        width: "100%",
        minHeight: "100%"
      }
    }
  },
  gridAllColumns: {
    gridTemplateColumns: "25% 25% 25% 25%"
  },
  carouselPage: {
    overflow: "hidden",
    borderBottomRightRadius: 6,
    borderBottomLeftRadius: 6
  },
  arrowButton: {
    "&::before": {
      content: "'' !important"
    },
    [`${a.breakpoints.down("sm")}`]: {
      top: 250
    }
  },
  mediaButtonsContainer: {
    position: "absolute",
    bottom: 20,
    left: 40,
    "@media screen and (max-width: 655px)": {
      right: 14,
      left: 14
    }
  }
}), v = 8, d = 5, G = ({ unit: a, classes: r }) => {
  const [f, h] = y(!1), [b, k] = y(0), m = V(), P = O(), s = L(P.breakpoints.down("sm")), t = u(
    () => [...a.property.listingImages ?? []].sort((o, e) => o.rank - e.rank).filter((o) => o.url).map((o) => ({
      id: o.id,
      src: o.url,
      label: o.fileName,
      caption: o.caption,
      mitsType: o.mitsType
    })),
    [a.property.listingImages]
  ), x = u(() => t.some((o) => o.mitsType === "FLOORPLAN"), [t]), C = () => {
    const o = m.current;
    o && o.open();
  }, l = (o) => {
    var e;
    (e = t[o]) != null && e.src && (h(!1), k(o), C());
  }, N = () => {
    var e;
    const o = t.slice(0, d);
    return /* @__PURE__ */ c("div", { className: g(r.carouselPage, r.firstPage), children: [
      /* @__PURE__ */ i(
        "div",
        {
          className: r.slideBlock,
          style: { backgroundImage: `url(${(e = o[0]) == null ? void 0 : e.src}` },
          onClick: () => l(0)
        }
      ),
      o.length > 1 && /* @__PURE__ */ i("div", { className: r.gridPage, children: o.slice(1, d).map((n, p) => /* @__PURE__ */ i(
        "div",
        {
          className: r.slideBlock,
          style: { backgroundImage: `url(${n == null ? void 0 : n.src}` },
          onClick: () => l(p + 1)
        },
        n.id
      )) })
    ] });
  }, S = () => {
    const o = j(
      t.slice(d, t.length),
      v
    );
    return o == null ? void 0 : o.map((e, n) => /* @__PURE__ */ i(
      "div",
      {
        className: g(r.carouselPage, r.gridPage, r.gridAllColumns),
        children: e == null ? void 0 : e.map((p, I) => /* @__PURE__ */ i(
          "div",
          {
            className: r.slideBlock,
            style: { backgroundImage: `url(${p.src}` },
            onClick: () => l(d + I + n * v)
          },
          p.id
        ))
      },
      n
    ));
  }, T = u(
    () => /* @__PURE__ */ i(
      M,
      {
        ref: m,
        options: f ? t.filter((o) => o.mitsType === "FLOORPLAN") : t,
        height: "50vh",
        initialSlide: b
      }
    ),
    [b, t, m, f]
  ), B = () => {
    var o;
    k(0), h(!0), (o = m.current) == null || o.open();
  };
  return /* @__PURE__ */ c("div", { className: r.container, children: [
    /* @__PURE__ */ c(
      W,
      {
        infinite: !0,
        dots: !1,
        useCSS: !1,
        lazyLoad: "ondemand",
        speed: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: /* @__PURE__ */ i(U, { size: w.medium, style: { top: 200 } }),
        prevArrow: /* @__PURE__ */ i(H, { size: w.medium, style: s ? { top: 200 } : void 0 }),
        children: [
          s && (t == null ? void 0 : t.map((o, e) => /* @__PURE__ */ i("div", { className: g(r.carouselPage, r.mobilePage), children: /* @__PURE__ */ i(
            "div",
            {
              className: r.slideBlock,
              style: { backgroundImage: `url(${o.src}` },
              onClick: () => l(e),
              children: /* @__PURE__ */ i(
                F,
                {
                  className: r.imageCounter,
                  size: "small",
                  label: `${e + 1}/${t.length}`
                }
              )
            }
          ) }, o.id))),
          !s && N(),
          !s && S()
        ]
      }
    ),
    /* @__PURE__ */ i("div", { className: r.mediaButtonsContainer, children: /* @__PURE__ */ i(
      A,
      {
        virtualTourUrl: a.property.virtualTourUrl,
        onViewPhotos: () => l(0),
        onViewFloorPlan: B,
        hideFloorPlan: !x
      }
    ) }),
    T
  ] });
}, qo = $(R(D, { name: "HeaderUnit" })(G));
export {
  qo as default
};
//# sourceMappingURL=UnitHeader.js.map
